import { render, staticRenderFns } from "./dialog-confirm-token.vue?vue&type=template&id=0c0aca5a&scoped=true"
import script from "./dialog-confirm-token.vue?vue&type=script&lang=js"
export * from "./dialog-confirm-token.vue?vue&type=script&lang=js"
import style0 from "./dialog-confirm-token.vue?vue&type=style&index=0&id=0c0aca5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0aca5a",
  null
  
)

export default component.exports